import React from 'react';
import { Link } from 'react-router-dom';
import AppLogo from '@/assets/logo.svg?react';
import { useConsentStore } from '@/stores/consentStore';

const Footer: React.FC = () => {
  const openPreferencesModal = useConsentStore((state) => state.openPreferencesModal);

  return (
    <footer className="footer border-t border-border/70 bg-foreground pb-8 pt-14 text-background print:hidden">
      <div className="container">
        <div className="mb-12 grid grid-cols-2 gap-8 md:grid-cols-4 lg:grid-cols-5">
          <div className="col-span-2 lg:col-span-1 mb-6 lg:mb-0">
             <Link to="/" className="flex items-center space-x-2 mb-4">
                <div className="rounded-lg bg-background p-1.5">
                    <AppLogo className="h-5 w-5 text-primary" />
                </div>
                <span className="text-xl font-bold tracking-tight text-background">RunOffTrack</span>
             </Link>
            <p className="text-sm leading-relaxed text-background/65">
              Free SWPPP tools, state permit references, and practical field guidance for construction teams.
            </p>
          </div>
          
          <div>
            <h2 className="mb-4 text-sm font-bold uppercase tracking-widest text-background">Product</h2>
            <ul className="space-y-3 text-sm text-background/65">
              <li><Link to="/features" className="hover:text-primary transition-colors">Features</Link></li>
              <li><Link to="/pricing" className="hover:text-primary transition-colors">Pricing</Link></li>
              <li><Link to="/solutions/for-consultants" className="font-medium transition-colors hover:text-primary">For Consultants</Link></li>
              <li><Link to="/swppp-requirements" className="hover:text-primary transition-colors">State Directory</Link></li>
            </ul>
          </div>

          <div>
            <h2 className="mb-4 text-sm font-bold uppercase tracking-widest text-background">Free Tools</h2>
            <ul className="space-y-3 text-sm text-background/65">
              <li><Link to="/tools/rain-event-finder" className="hover:text-primary transition-colors">Rain Event Finder</Link></li>
              <li><Link to="/tools/map-sketcher" className="hover:text-primary transition-colors">Map Sketcher</Link></li>
              <li><Link to="/tools/fine-calculator" className="hover:text-primary transition-colors">Fine Calculator</Link></li>
              <li><Link to="/tools/runoff-calculator" className="hover:text-primary transition-colors">Runoff Calc</Link></li>
              <li><Link to="/resources/vegetation-density" className="hover:text-primary transition-colors">Vegetation Visualizer</Link></li>
            </ul>
          </div>

          <div>
            <h2 className="mb-4 text-sm font-bold uppercase tracking-widest text-background">Resources</h2>
            <ul className="space-y-3 text-sm text-background/65">
              <li><Link to="/resources/bmp-field-guide" className="hover:text-primary transition-colors">BMP Field Guide</Link></li>
              <li><Link to="/resources/templates" className="hover:text-primary transition-colors">Inspection Templates</Link></li>
              <li><Link to="/resources/toolbox-talks" className="hover:text-primary transition-colors">Toolbox Talks</Link></li>
              <li><Link to="/blog" className="hover:text-primary transition-colors">Blog</Link></li>
            </ul>
          </div>

          <div>
            <h2 className="mb-4 text-sm font-bold uppercase tracking-widest text-background">Legal</h2>
            <ul className="space-y-3 text-sm text-background/65">
              <li><Link to="/privacy-policy" className="hover:text-primary transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms-of-service" className="hover:text-primary transition-colors">Terms of Service</Link></li>
              <li><Link to="/cookie-policy" className="hover:text-primary transition-colors">Cookie Policy</Link></li>
              <li><Link to="/contact" className="hover:text-primary transition-colors">Contact Us</Link></li>
              <li><Link to="/about/daniel-gaskins" className="hover:text-primary transition-colors">About the Creator</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="flex flex-col items-center justify-between border-t border-background/15 pt-8 text-xs text-background/55 md:flex-row">
          <p>
            &copy; {new Date().getFullYear()} RunOffTrack Inc. Created by{' '}
            <a href="https://danielgaskins.com/" className="font-medium text-background transition-colors hover:text-primary">
              Daniel Gaskins
            </a>.
          </p>
          <div className="flex gap-4 mt-2 md:mt-0">
             <Link to="/sitemap.xml" className="hover:text-primary transition-colors" target="_blank">Sitemap</Link>
             <button onClick={() => openPreferencesModal()} className="hover:text-primary transition-colors underline underline-offset-4">
                Cookie Preferences
             </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
